<template>
    <div class="m-auto w-100 pb-30">
        <div class="register-form__header">
            <div class="register-form__title" :style="is_mobile ? 'font-size: 33px;' : ''">Try PPC Shield free for 14 days</div>
            <div class="subscription__trial">
                <div style="padding-top: 5px;">
                    💰 You will not be charged until after your free trial ends
                </div>
                <div style="padding: 5px 0;">
                    ✉️ We will send you a reminder email before a free trial ends
                </div>
            </div>

        </div>
        <div class="subscription">
            <custom-input
                name="selected_plan"
                type="select"
                v-model="selected_plan"
                value_name="name"
                :select_options="plan_options"
                :onSelect="getPlanInfo"
                styled="standard"
                classes="custom-field-f16"
            ></custom-input>

            <div v-if="loading">Loading...</div>
            <template v-else>
                <template v-if="selected_plan.name === 'Basic Plan'">
                    <ul>
                        <li>Unlimited Ads Accounts</li>
                        <li>Up to 5,000 Ad Clicks per month</li>
                        <li>Cancel risk-free within the first 14 days</li>
                    </ul>
                </template>
                <template v-else-if="selected_plan.name === 'Standard Plan'">
                    <ul>
                        <li>Unlimited Ads Accounts</li>
                        <li>Up to 10,000 Ad Clicks per month</li>
                        <li>Cancel risk-free within the first 14 days</li>
                    </ul>
                </template>
                <template v-else-if="selected_plan.name === 'Professional Plan'">
                    <ul>
                        <li>Unlimited Ads Accounts</li>
                        <li>Up to 100,000 Ad Clicks per month</li>
                        <li>Cancel risk-free within the first 14 days</li>
                    </ul>
                </template>

                <div class="subscription__billing space-between">
                    <div style="white-space: nowrap; font-weight: bold;">Billing cycle</div>
                    <div class="radio-buttons">
                        <div class="ml-2">
                            <input type="radio" id="monthly" name="price_time" :value="monthly_price.price_id" v-model="price_id">
                            <label for="monthly">Monthly</label>
                        </div>
                        <div class="ml-2">
                            <input type="radio" id="annual" name="price_time" :value="annual_price.price_id" v-model="price_id">
                            <label for="annual">Annual (save 20%)</label>
                        </div>
                    </div>
                </div>
                <div class="space-between price">
                    <div>Price</div>
                    <div v-if="!price_old">${{price}}</div>
                    <div v-else>
                        <span class="price-old">${{price_old}}</span>
                        <span class="price-new">${{price}}</span>
                    </div>
                </div>
                <div class="space-between green total_price">
                    <div>TOTAL DUE NOW</div>
                    <div>$0</div>
                </div>
                <form method="POST" action="start-new-subscription">
                    <input type="hidden" id="price_id" name="price_id" v-bind:value="price_id"/>
                    <input type="hidden" id="plan_id" name="plan_id" v-bind:value="selected_plan.plan_id"/>
                    <button class="mt-2 btn w-100" type="submit">NEXT</button>
                </form>
                <div style="display: flex; justify-content: center; margin-top: 20px;">
                    <img src="/images/Safe_checkout.jpg" alt="Safe checkout"
                         style="max-width: 393px; width: 100%; height: auto; align-self: flex-start;"
                    >
                </div>
                <div style="font-size: 14px; color: #636b6f; text-align: center;">
                    <div>You are signed in as {{user_email}}</div>
                    <div>To sign out please <a href="/logout" style="color: #2280fe; text-decoration: underline;">click here</a>.</div>
                </div>
                <div style="font-size: 12px; color: #636b6f; text-align: center; margin-top: 5px;">
                    <span>The prices are in US dollars</span>
                </div>
            </template>
        </div>

        <modal :height="'auto'" :width="'400px'" name="user-changed" :clickToClose="false">
            <div class="informative-modal flex flex-col">
                <div class="header">Session Expired</div>

                <div class="body">
                    Our system has detected that you have accessed another customer account from a new tab. It is not possible to view more than one account at same time. Please note that the displayed information will apply to the most recently viewed customer account.
                </div>

                <div class="footer flex justify-end space-x-2">
                    <button class="btn btn-primary" @click="reloadWindow()">Close</button>
                </div>
            </div>
        </modal>

    </div>
</template>
<script>
    export default {
        name: 'first-select-subscription',
        props: ['plan', 'user_email', 'release'],
        data: function () {
            return {
                loading: true,
                price_id: '1',
                monthly_price: {price_id: '1', cost: 0, cost_old: 0},
                annual_price: {price_id: '2', cost: 0, cost_old: 0},
                selected_plan: '',
                plan_options: this.release === 'production' ? [
                    {name: 'Basic Plan', plan_id: 'prod_IX9Dq2mkTkVMJt'},
                    {name: 'Standard Plan', plan_id: 'prod_IXAcu57fcVsXGD'},
                    {name: 'Professional Plan', plan_id: 'prod_IXAdp5ytUf571U'},
                ] : [
                    {name: 'Basic Plan', plan_id: 'prod_IZ3QeJMZncagRc'},
                    {name: 'Standard Plan', plan_id: 'prod_IZ3tTq6HQezz2d'},
                    {name: 'Professional Plan', plan_id: 'prod_J5XEVxCCeJFuh6'},
                ],
                is_mobile: window.innerWidth < 992,
                loaded_user_id: null,
            }
        },
        methods: {
            getPlanInfo(){
                this.loading = true;
                axios.get('get-plan-info?plan='+this.selected_plan.plan_id)
                    .then(data => {
                        this.monthly_price = data.data.monthly_price;
                        this.annual_price = data.data.annual_price;
                        this.price_id = data.data.monthly_price.price_id;
                        this.loading = false;
                    })
                    .catch(err => console.log('err', err));
            },
            reloadWindow(){
                location.href = '/account';
            },
            checkActiveUser(){
                axios.post('/notification/getCurrentUserId')
                    .then(data => {
                        if(!this.loaded_user_id) this.loaded_user_id = data.data;
                        else{
                            if(this.loaded_user_id != data.data){
                                this.$modal.show('user-changed');
                            }
                        }
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            this.$modal.show('user-changed');
                        }
                    });
            }
        },
        computed: {
            price: function (){
                if(this.price_id === this.annual_price.price_id) return this.annual_price.cost;
                else return this.monthly_price.cost;
            },
            price_old: function (){
                if(this.price_id === this.annual_price.price_id) return this.annual_price.cost_old;
                else return this.monthly_price.cost_old;
            },
        },
        mounted() {
            setInterval(() => {
                this.checkActiveUser();
            }, 3000);
            const plan_id = this.plan;
            const option = this.plan_options.filter(function (value) {
                return value.plan_id === plan_id;
            });
            if(option.length > 0) this.selected_plan = option[0];
            this.getPlanInfo();
        }
    }
</script>
